import { useContext } from 'react';
import { useFoundersContext } from '../../contexts/founders-context';
import { UserContext } from '../../contexts/user-context';
import { ModalV2 } from '../common';
import AssignFoundersVentureForm from '../forms/assign-founders-venture';

function FounderAssignModal() {
  const { hasAccessToAction } = useContext(UserContext);
  const {
    assignTargetFounder,
    isAssigningFounder,
    loadedVenturesById,
    handleVenturesLoaded,
    handleAssingSuccessForm,
    setAssignTargetFounder,
  } = useFoundersContext();

  const handleClose = () => {
    setAssignTargetFounder(null);
  };

  return hasAccessToAction('founder.details.update') &&
    !!assignTargetFounder ? (
    <ModalV2
      open={true}
      onClose={handleClose}
      titleProps={{
        title: 'New assignment',
        caption: `${assignTargetFounder.firstName} ${assignTargetFounder.lastName}`,
      }}
      width='720px'>
      <AssignFoundersVentureForm
        founderId={assignTargetFounder.id}
        loading={isAssigningFounder[assignTargetFounder.id]}
        onLoaded={handleVenturesLoaded(assignTargetFounder.id)}
        ventures={loadedVenturesById[assignTargetFounder.id]}
        onSuccess={handleAssingSuccessForm(assignTargetFounder.id, handleClose)}
        onCancel={handleClose}
      />
    </ModalV2>
  ) : null;
}

export default FounderAssignModal;
